import { render, staticRenderFns } from "./ticket_root_language_codes.vue?vue&type=template&id=2ab9b50c&scoped=true&"
import script from "./ticket_root_language_codes.vue?vue&type=script&lang=js&"
export * from "./ticket_root_language_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9b50c",
  null
  
)

export default component.exports